/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TrackItMeasurementParameterDto } from './TrackItMeasurementParameterDto';
import {
    instanceOfTrackItMeasurementParameterDto,
    TrackItMeasurementParameterDtoFromJSON,
    TrackItMeasurementParameterDtoFromJSONTyped,
    TrackItMeasurementParameterDtoToJSON,
} from './TrackItMeasurementParameterDto';

/**
 * @type TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter
 * 
 * @export
 */
export type TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter = TrackItMeasurementParameterDto;


export function TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterFromJSON(json: any): TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter {
    return TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterFromJSONTyped(json, false);
}

export function TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...TrackItMeasurementParameterDtoFromJSONTyped(json, true) };
    return  TrackItMeasurementParameterDtoFromJSONTyped(json, true);
}

export function TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterToJSON(value?: TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfTrackItMeasurementParameterDto(value)) {
        return TrackItMeasurementParameterDtoToJSON(value as TrackItMeasurementParameterDto);
    }

    return {};
}

/**
 * Check if a given object implements the TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter interface.
 */
export function instanceOfTrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter(value: any): value is TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter {
    if (instanceOfTrackItMeasurementParameterDto(value)) return true;
    return false;
}

